<div *ngIf="isLogged">
    <div class="breadcrumbGlobal">
        <a [routerLink]="['/mydashboard']">
            <mat-icon>home</mat-icon>
        </a>
        <mat-icon>chevron_right</mat-icon>
        <span translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</span>
    </div>
    <tb-header specificTitle="SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT"></tb-header>
    <div class="contentGlobal">
        <div style="display: flex; justify-content: center; flex-wrap: wrap">
            <div *ngIf="isAdmin">
                <ms-account-management-card></ms-account-management-card>
            </div>
            <div *ngIf="hasAnAssociatedSubscription">
                <ms-subscription-management-card></ms-subscription-management-card>
            </div>
            <div *ngIf="isImpExpAdmin && !this.storeRolesService.isBetaTester">
                <ms-import-export-management-card></ms-import-export-management-card>
            </div>
            <div *ngIf="this.storeRolesService?.IsInternal && !this.storeRolesService?.isBetaTester">
                <ms-magocloud-personal-sub></ms-magocloud-personal-sub>
            </div>
            <div *ngIf="this.storeRolesService?.IsInternal || this.storeRolesService?.isBetaTester">
                <ms-magoweb-personal-sub></ms-magoweb-personal-sub>
            </div>

            <div
                *ngIf="
                    (!this.storeRolesService.IsInternal && this.customerService.canSeeNFSSection && !this.storeRolesService.isBetaTester) ||
                    this.storeRolesService.isWebSiteAdmin
                "
            >
                <ms-nfs-card></ms-nfs-card>
            </div>
        </div>
    </div>
</div>
